import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {API_PATH} from "../../components/const";
import axios from "axios";
import {Button, Modal} from "antd";
import {toast} from "react-toastify";

const ImportExcel = () => {
    const [file, setFile] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [failedList, setFailedList] = useState([])
    const [downloadLink, setDownloadLink] = useState("")
    const [status, setStatus] = useState(false)
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('file', file);

    axios.post(API_PATH + "user/company/" + localStorage.getItem('id') + "/check-employee/by-rar-zip",
        formData,
        {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
        .then(response => {
            setStatus(response.data?.success)
            if (response.data?.success){
                axios.post(API_PATH + "user/company/" + localStorage.getItem('id') + "/create-employee/by-rar-zip",
                    formData,
                    {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                    .then(response => {
                        localStorage.setItem("task_id", response?.data?.task_id)
                        toast.success("Успешно отправлена")
                    })
            } else {
                setIsModalOpen(true)
                setFailedList(response?.data?.error_employee_data)
                setDownloadLink(response?.data?.excel_url)
            }
        })
        .catch(error => {
            console.error(error);
        });
};
    const handleOk = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('file', file);

        axios.post(API_PATH + "user/company/" + localStorage.getItem('id') + "/create-employee/by-rar-zip",
            formData,
            {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(response => {
                setStatus(false)
                setIsModalOpen(false)
                localStorage.setItem("task_id", response?.data?.task_id)
            })
    }
    return (
        <div className="profile-edit">
            <div className="progress-link">
                <Link to="/main/visitor-home"> <img src="/icon/Icon1.svg" alt="."/></Link>
                <img src="/icon/arrowleft.svg" alt="."/>
                <Link to="/main/hr-admin/employees"> <span>Cотрудники</span></Link>
                <img src="/icon/arrowleft.svg" alt="."/>
            </div>

            <div className="profile-header d-flex justify-content-between">
                <h3 className="font-family-medium">Импортировать Excel</h3>
            </div>

            <div className="p-4 w-25">
                <form onSubmit={handleSubmit}>
                    <input className="w-100 border-light-my-input p-2" type="file" onChange={handleFileChange} />
                    <button className="w-100 mt-2 add-btn" type="submit">Загрузить</button>
                </form>
            </div>

            <Modal title="Внимание!"
                   open={isModalOpen}
                   onCancel={() => setIsModalOpen(false)}
                   footer={[
                       <Button key="submit" type="default" onClick={() => setIsModalOpen(false)}>
                           Отменить
                       </Button>,
                       <Button key="submit" type="primary" onClick={handleOk}>
                           Дa
                       </Button>
                   ]}
            >
                {
                    failedList?.slice(0, 10)?.map((item, index) =>(
                        <p className="text-white">{item?.error_text + ", "}</p>
                    ))
                }
                {
                    failedList?.slice(0, 10) > 0 ?
                        <p>...............</p>
                        :
                        ""
                }
                <h6 className="text-success text-center fw-bold  mb-3">У вас возникли проблемы с заполнением таблицы сотрудников. Подробно ее можно просмотреть в Excel. <a
                    href={downloadLink} className="text-decoration-underline">ссылка для скачивания</a></h6>
            </Modal>
        </div>
    );
};

export default ImportExcel;